export const keyboardShortcuts = {
  bold: 'Mod-b',
  bulletList: 'Mod-Shift-8',
  italic: 'Mod-i',
  link: 'Mod-k',
  orderedList: 'Mod-Shift-7',
  paragraph: 'Mod-Alt-0',
  underline: 'Mod-u',
}
